module.exports = __webpack_public_path__ + "fonts/Barlow-Black.77929e79.eot";